<template>
  <div>
    <transition name="fade">
      <div class="out" v-if="showModal">
        <div class="common-small-dialog-wrap">
          <div class="common-small-dialog-content">
            <div class="dialog-center-bg"></div>
            <div class="dialog-close-btn" @click="close()"></div>
            <div class="dialog-header">
              <div>直推用户</div>
            </div>
            <div class="consume-reward-content">
              <div class="vip-rule-detail" v-if="lists.length > 0">
                <div class="vip-reward-rule-box" @scrolltolower="getLists">
                  <div
                    class="reward-rule-title"
                    style="font-size: 24rpx; color: #fff"
                  >
                    <div class="col-1">ID</div>
                    <div class="col-2">昵称</div>
                  </div>
                  <div
                    v-for="(item, index) in lists"
                    :key="index"
                    class="rule-item"
                  >
                    <div class="col-1">{{ item.userId }}</div>
                    <div class="col-2">{{ item.nickName }}</div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; margin-top: 10%" v-else>
                <div class="no-data" style="margin-top: unset;">
                  <div class="empty-box-new"></div>
                  <div class="tip-text">暂无直推用户</div>
                </div>
              </div>
            </div>
            <div class="dialog-footer"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { getUserChildInfo } from "@/api/index";
export default {
  data() {
    return {
      page: 1,
      limit: 30,
      isOver: false,
      lists: [],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getLists() {
      getUserChildInfo().then((res) => {
        if (res.data.code == 200) {
          this.lists = res.data.data;
        } else {
          this.$message({ duration: 1000,
            message:res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
      //   if (this.isOver) {
      //     return;
      //   }
      //   let params = {
      //     page: this.page,
      //     limit: this.limit,
      //   };
      //   this.$utils
      //     .requestGet("/api/user/team", params, "加载中", true)
      //     .then((res) => {
      //       if (!res.errMsg) {
      //         if (this.page == 1) {
      //           this.lists = res.data.list;
      //         } else {
      //           this.lists = this.lists.concat(res.data.list);
      //         }
      //         if (res.data.list.length < this.limit) {
      //           this.isOver = true;
      //         }
      //         this.page++;
      //       } else {
      //         this.soundPlay("opFail");
      //         this.$refs.uNotify.show({
      //           top: 10,
      //           type: "error",
      //           color: "#ffffff",
      //           bgColor: "transparent",
      //           message: res.errMsg,
      //           duration: 1000 * 2,
      //           fontSize: "3.47vw",
      //           safeAreaInsetTop: true,
      //         });
      //       }
      //     });
    },
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(newValue, oldValue) {
      if (newValue) {
        this.page = 1;
        this.isOver = false;

        this.getLists();
      }
    },
  },
};
</script>
    <style lang="scss" scoped>
@import "../../assets/style/modal.scss";
.out {
  width: 100%;
  // max-width: 525px;
  height: 100vh;
  transform: translateX(-50%);
  position: fixed;
  left: 50%;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  @media (max-width: 550px) {
    width: 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.common-small-dialog-wrap {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.backpack-page .buy-back-dialog .buy-box img {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
}

.backpack-page .buy-back-dialog .cancel-btn {
  margin-right: 5.33 * 4.2px;
}

.backpack-page .buy-back-dialog,
.backpack-page .password-dialog,
.backpack-page .link-dialog,
.backpack-page .tips-dialog {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.backpack-page .buy-back-dialog .sure-btn,
.backpack-page .password-dialog .sure-btn,
.backpack-page .link-dialog .sure-btn,
.backpack-page .tips-dialog .sure-btn,
.backpack-page .buy-back-dialog .cancel-btn,
.backpack-page .password-dialog .cancel-btn,
.backpack-page .link-dialog .cancel-btn,
.backpack-page .tips-dialog .cancel-btn {
  width: 28.67 * 4.2px;
  height: 8 * 4.2px;
  background-size: 28.67 * 4.2px 8 * 4.2px;
  text-align: center;
  line-height: 8 * 4.2px;
}

.backpack-page .buy-back-dialog .sure-btn,
.backpack-page .password-dialog .sure-btn,
.backpack-page .link-dialog .sure-btn,
.backpack-page .tips-dialog .sure-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/images/submit_btn.png") no-repeat 0 0;
  background-size: contain;

  width: 26.67 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
}

.backpack-page .buy-back-dialog .cancel-btn,
.backpack-page .password-dialog .cancel-btn,
.backpack-page .link-dialog .cancel-btn,
.backpack-page .tips-dialog .cancel-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/images/del_confirm_btn.png") no-repeat 0 0;
  background-size: contain;

  width: 26.67 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
}
.btn-group {
  position: absolute;
  bottom: -80px;
}
// 直推用户样式
.consume-reward-content .vip-detail-dialog .vip-rule-detail {
  // padding-top: 4*4.2px;
}

.consume-reward-content .vip-detail-dialog .vip-rule-detail .vip-text {
  width: 71.6 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/vip_dialog_top_bg.png") no-repeat 0 0;
  background-size: 71.6 * 4.2px 5.47 * 4.2px;
  margin: 0 auto;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  text-align: center;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box {
  width: 73.33 * 4.2px;
  height: 100 * 4.2px;
  margin: 0 auto;
  padding-top: 4.4 * 4.2px;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .reward-rule-title {
  width: 73.33 * 4.2px;
  height: 7.6 * 4.2px;
  background: url("../../assets/images/vip_dialog_table_header_bg.png")
    no-repeat 0 0;
  background-size: 73.33 * 4.2px 7.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .reward-rule-title
  > div {
  float: left;
  line-height: 7.6 * 4.2px;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .col-1 {
  width: 31.73 * 4.2px;
  height: 7.6 * 4.2px;
  margin-right: 0.53 * 4.2px;
  text-align: center;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .col-2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 7.6 * 4.2px;
  text-align: center;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .rule-item {
  width: 73.33 * 4.2px;
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .rule-item.sel:before {
  content: "";
  width: 73.33 * 4.2px;
  height: 6.13 * 4.2px;
  background: url("../../assets/images/vip_dialog_tb_item_sel.png") no-repeat 0
    0;
  background-size: 73.33 * 4.2px 6.13 * 4.2px;
  position: absolute;
  left: 0;
  top: -0.27 * 4.2px;
  z-index: 5;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .rule-item
  > div {
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  position: relative;
  z-index: 10;
}

.consume-reward-content
  .vip-detail-dialog
  .vip-rule-detail
  .vip-reward-rule-box
  .rule-item:after {
  content: "";
  display: block;
  width: 71.47 * 4.2px;
  height: 1px;
  background: url("../../assets/images/line11.png") no-repeat 0 0;
  background-size: 71.47 * 4.2px 1px;
  position: absolute;
  left: 0.93 * 4.2px;
  bottom: 0;
  z-index: 2;
}
</style>